import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=412488a8&scoped=true&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"
import style0 from "./FormToggle.vue?vue&type=style&index=0&id=412488a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412488a8",
  null
  
)

export default component.exports